import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { TokenStorageService } from '../_services/token-storage.service';
import {LangService} from '@app/_services/lang.service';


const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  private authService: TokenStorageService;
  private langService: LangService | undefined;

  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to the api url
    let authReq = request;
    this.authService = this.injector.get(TokenStorageService); // get it here within intercept
    this.langService = this.injector.get(LangService);

    const token = this.authService.getToken();
    const lang = this.langService.getLanguage();
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    if (token != null) {
      authReq = request.clone({
        headers: request.headers.set(TOKEN_HEADER_KEY, token).set('language', lang),
      });
    }
    return next.handle(authReq);
  }
}

